import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-success py-20 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-76">
          <div className="bg-white p-4 rounded-full shadow-lg mb-8" data-id="element-77">
            <ShieldCheck className="w-16 h-16 text-gold" data-id="element-78" />
          </div>

          <h2 className="text-3xl md:text-4xl text-navy mb-6" data-id="element-79">
            Tu Inversión Está 100% Protegida
          </h2>

          <p className="text-lg md:text-xl text-navy/80 leading-relaxed max-w-2xl" data-id="element-80">
            Si después de leer el Blueprint completo sientes que no fue lo que
            esperabas, escríbenos en los próximos 7 días y te devolvemos cada
            centavo. Sin preguntas. Sin drama. Con la misma paz con la que
            empezamos.
          </p>

          <p className="text-xl font-bold text-navy mt-6" data-id="element-81">
            El riesgo es completamente nuestro.
          </p>
        </motion.div>
      </div>
    </section>;
}